import React, { type CSSProperties } from 'react';

import { cn } from '../../lib/utils';

import { View } from '../common/View';

type ToggleProps = {
  id: string;
  isOn: boolean;
  isDisabled?: boolean;
  onToggle?: (isOn: boolean) => void;
  className?: string;
  style?: CSSProperties;
};

// Modernized switch: smooth animation, shadcn token colors.
// Renders a hidden native checkbox so existing form-handling still works.
const trackClasses = cn(
  'relative inline-flex items-center w-9 h-5 rounded-full cursor-pointer',
  'transition-colors duration-200',
  'shadow-inner',
);

const thumbClasses = cn(
  'inline-block w-4 h-4 rounded-full bg-white',
  'shadow transition-transform duration-200 ease-out',
  'translate-x-0.5',
);

export const Toggle = ({
  id,
  isOn,
  isDisabled = false,
  onToggle,
  className,
  style,
}: ToggleProps) => {
  return (
    <View style={style} className={className}>
      <input
        id={id}
        checked={isOn}
        disabled={isDisabled}
        onChange={e => onToggle?.(e.target.checked)}
        className="sr-only"
        type="checkbox"
      />
      <label
        data-toggle-container
        data-on={isOn}
        htmlFor={id}
        className={cn(
          trackClasses,
          isOn ? 'bg-primary' : 'bg-muted',
          isDisabled && 'opacity-50 cursor-not-allowed',
        )}
      >
        <span
          data-toggle
          data-on={isOn}
          className={cn(
            thumbClasses,
            isOn && 'translate-x-[18px]',
            isDisabled && 'bg-muted-foreground',
          )}
        />
      </label>
    </View>
  );
};
